import React, {useRef} from 'react';
import Text from "@/components/common/Text";
import styled from "styled-components";
import {gsap} from "/utils/gsap";
import {getCssSizeValue} from "@/utils/utils";
import {colors} from "@/styles/themeSettings";
import {ScrollTrigger, useGSAP} from "@/utils/gsap";


const Wrapper  = styled.div`
	display: flex;
	padding: 0 ${getCssSizeValue(20)};
	flex-direction: column;
	max-width: ${getCssSizeValue(540)};
	
	.text{
		text-transform: uppercase;
		padding-bottom: ${getCssSizeValue(40)};
		
		&.active {
			font-weight: ${({ theme }) => theme.fontWeight.bold};
		}
	}
`
const Elevator = ({ data = [], current = {}, index=0 }) => {
	const WrapperRef = useRef()
	const items = data || []

	useGSAP(() => {
		const oneItemShiftPercent = 1/items.length //how much percent wrapper should translate
		const centerShiftPercent = 0.5 //align top of the wrapper with center of the screen
		const yPercent = (centerShiftPercent - oneItemShiftPercent * index) * 100

		gsap.to(WrapperRef.current, {
			yPercent
		})

		ScrollTrigger.refresh()
	},{
		dependencies: [index, items]
	})

	return (
		<Wrapper ref={WrapperRef}>
			{items.map((item, index) => {
				const activeId = current?.id || ''
				const id = item?.id || ''
				return (
					<Text color={colors.richBlack} className={`typo-borna typo-borna-107 ${activeId === id ? 'active' : ''}`} key={item?.id || index}>
						{item.title}
					</Text>
				)
			})}
		</Wrapper>
	);
};

export default Elevator;